"use strict";

var _toConsumableArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useReactiveReactProp = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var components_1 = require("../../components");

var useReactiveReactProp = function useReactiveReactProp(currentHandle, filter) {
  var reactifySearchContext = (0, hooks_1.useReactifySearchContext)();

  var _ref = (0, hooks_1.useFilters)(),
      filterStack = _ref.filterStack;

  var sensorIds = (0, components_1.SENSOR_IDS)(reactifySearchContext.options.mode, reactifySearchContext.config);
  var reactProp = react_1.default.useMemo(function () {
    var _a, _b;

    if (filter && filter.settingsShowEmptyValues) {
      return {
        and: sensorIds
      };
    }

    return {
      and: [].concat(_toConsumableArray(sensorIds), _toConsumableArray((_a = reactifySearchContext.options.additionalComponentIds) !== null && _a !== void 0 ? _a : []), _toConsumableArray((_b = filterStack === null || filterStack === void 0 ? void 0 : filterStack.options.map(function (filter) {
        return filter.handle;
      })) !== null && _b !== void 0 ? _b : [])).filter(function (handle) {
        return handle !== currentHandle;
      })
    };
  }, [filterStack, currentHandle, reactifySearchContext.options.additionalComponentIds]);
  return reactProp;
};

exports.useReactiveReactProp = useReactiveReactProp;